import { createRouter, createWebHistory } from 'vue-router';

import Home from '@/pages/Home.vue';
import Contact from '@/pages/Contact.vue';
import Pricing from '@/pages/Pricing.vue';
import Partners from '@/pages/Partners.vue';
import Reviews from '@/pages/Reviews.vue';
import Legal from '@/pages/Legal.vue';
import NotFound from '@/pages/NotFound.vue';

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/contact', name: 'Contact', component: Contact },
  { path: '/pricing', name: 'Pricing', component: Pricing },
  { path: '/partners', name: 'Partners', component: Partners },
  { path: '/terms', name: 'Legal', component: Legal },
  { path: '/testimonials', name: 'Reviews', component: Reviews },

  // Catch-all 404 route
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
